import React from "react";
import ToHomeButton from "../buttons/ToHomeButton";
import MainCanvas from "../canvas/MainCanvas";
import TextForm from "../canvas/TextForm";

function Correct() {
  return (
    <div className="page">
      <h1 className="heading-hero mb-6">誤り修正ページ</h1>
      <div className="card-wide flex flex-col items-center gap-4">
        <MainCanvas imagePath="/drawing/monkeyFalse.png" />
        <TextForm />
        <div className="row-center">
          <ToHomeButton buttonText="Home画面に戻る" />
        </div>
      </div>
    </div>
  );
}

export default Correct;
